// import moment from 'moment';
import Model from 'lib/Model';
import { v4 as uuid } from 'uuid';
import config from 'config';
import * as repo from 'db/repositories';
import { hydratePondFromApi } from 'db/hydrate';
import Visit from 'model/Visit';
import Image from 'model/Image';

export default Model.extend({
	defaults: function()
	{
		var now = new Date();
		return {
			status: 'new',
			image_list: [],
			is_published: true,
			created_at: now.getTime(),
			uuid: uuid()
		};
	},

	idAttribute: 'uuid',

	toString: function() {
		return this.has('id') ? 'mares n°'+this.get('id') : 'nouvelle mare';
	},

	validate: function( attrs )
	{
		var error = {}

		if( !attrs.user_uuid )
		{
			if( !_.isString( attrs.user_email ) )
			{
				error.user_email = "Veuillez fournir une adresse email";
			}
			else if( !attrs.user_email.match( /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/ ) )
			{
				error.user_email = "Veuillez fournir une adresse email valide";
			}

			if( _.isNumber( attrs.user_zip ) )
			{
				attrs.user_zip = attrs.user_zip.toString();
			}

			if( !_.isString( attrs.user_zip ) )
			{
				error.user_zip = "Veuillez fournir un code postal";
			}
			else if( !attrs.user_zip.match( /(\d{2}|2[AB])\s?\d{3}/ ) )
			{
				error.user_zip = "Le code postal fourni ne semble pas correct";
			}
			else if ( !repo.findByZip( attrs.user_zip.replace( /\s/g, '' ) ) )
			{
				error.user_zip = "Ce code postal n'existe pas…";
			}
		}

		if( !_.isNumber( attrs.lat ) || !_.isNumber( attrs.lng ) )
		{
			error.lat = "Aucune coordonnées géographique fournie";
		}
		// Contrôle territoire : async dans le formulaire (getClosest)

		if( _.size( error ) ) return error;
	},

	getStatus: function()
	{
		var status = this.get('status');
		return _.has( config.status_list, status ) ? config.status_list[status] : { name: "Inconnu", color: "dark"  };
	},

	getStatusList: function()
	{
		return {
			new:     { name: 'À confirmer'  , color: "warning text-white" },
			snaped:  { name: 'À décrire'    , color: "info"               },
			visited: { name: 'Décrite'      , color: "success"            },
			lost:    { name: 'Non retrouvée', color: "danger"             },
		};
	},


	getZone: function()
	{
		return this._zone || null;
	},

	getVisitList: function()
	{
		if( this._visitModels )
		{
			return this._visitModels;
		}

		this._visitModels = _.map( this._visitRows || [], function( row )
		{
			return new Visit( row, { parse: true } );
		} );

		return this._visitModels;
	},

	getImageList: function()
	{
		if( this._imageModels )
		{
			return this._imageModels;
		}

		this._imageModels = _.map( this._imageRows || [], function( row )
		{
			return new Image( row );
		} );

		return this._imageModels;
	},

	isLocated: function()
	{
		return this.has('lat') && this.has('lng');
	},
	getLatLng: function()
	{
		return { lat: this.get('lat'), lng: this.get('lng') };
	},

	fetchRelated: function( options )
	{
		if( !app.is('online') || this.isNew() )
		{
			return $.Deferred().resolve().promise();
		}

		// Brouillon local : ne pas hydrater depuis l'API
		if( this.isSavable() )
		{
			return $.Deferred().resolve().promise();
		}

		var self = this;
		var deferred = $.Deferred();

		hydratePondFromApi( this.get( 'uuid' ) ).done( function( ok )
		{
			if( !ok )
			{
				deferred.resolve();
				return;
			}

			Promise.all( [
				repo.getVisitsByPond( self.get( 'uuid' ) ),
				repo.getImagesByPond( self.get( 'uuid' ) ),
			] ).then( function( related )
			{
				self._visitRows = related[0] || [];
				self._imageRows = related[1] || [];
				self._visitModels = null;
				self._imageModels = null;
				self.trigger( 'change' );
				deferred.resolve();
			} ).catch( function()
			{
				deferred.resolve();
			} );
		} );

		return deferred.promise();
	}

});
